function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 112.009L155.708 2H643.75L705.375 46.1048H1291.42L1341 81.5915V699.868H718.833L620.375 770.334H155.708L50.1667 694.798H2V112.009Z",
  fill: "url(#paint8_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 112.009L155.708 2H643.75L705.375 46.1048H1291.42L1341 81.5915V699.868H718.833L620.375 770.334H155.708L50.1667 694.798H2V112.009Z",
  stroke: "#FF15BD",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2 112.009L155.708 2H643.75L705.375 46.1048H1291.42L1341 81.5915V699.868H718.833L620.375 770.334H155.708L50.1667 694.798H2V112.009Z",
  stroke: "url(#paint9_linear)",
  strokeOpacity: 0.9,
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 2.32512,
  y1: 251.312,
  x2: 1242.9,
  y2: 251.312,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#702AE3",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0F3EB7",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 1228,
  y1: 2.00037,
  x2: 197.212,
  y2: -134.839,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00393049,
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})));

function SvgFeaturedContentBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1343 772",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedContentBg);
export default __webpack_public_path__ + "static/media/featured-content-bg.23a32b70.svg";
export { ForwardRef as ReactComponent };